var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeoplebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.25C11.25 12.5931 9.23528 11.25 6.75 11.25C4.26472 11.25 2.25 12.5931 2.25 14.25M14.25 12V9.75M14.25 9.75V7.5M14.25 9.75H12M14.25 9.75H16.5M6.75 9C5.09315 9 3.75 7.65685 3.75 6C3.75 4.34315 5.09315 3 6.75 3C8.40685 3 9.75 4.34315 9.75 6C9.75 7.65685 8.40685 9 6.75 9Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplebtn);
export default __webpack_public_path__ + "static/media/peoplebtn.bd415fa8f9931b76b62c6ab7bc57b9c2.svg";
export { ForwardRef as ReactComponent };